import * as Phaser from "phaser";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";

export class CrystalIndicator extends Phaser.GameObjects.Container {
  private image: Phaser.GameObjects.Image;
  private text: Phaser.GameObjects.Text;

  constructor(private myScene: BasicScene, x: number, y: number) {
    super(myScene, x, y);

    this.image = myScene.add.image(
      0,
      0,
      myScene.atlas,
      myScene.keys.assets.sprites.ui.indicatorCrystal,
    )
      .setScale(1)
      .setOrigin(0.5, 0.5)
      .setPosition(0, 0)
      .setInteractive({ useHandCursor: true });

    this.scene.tweens.add({
      targets: this.image,
      rotation: { from: -0.2, to: 0.2 },
      duration: 300,
      ease: "Sine.easeIn",
      yoyo: true,
      hold: 5000,
      delay: 3000 + Math.random() * 5000,
      repeat: -1,
    });

    this.text = myScene.add.text(0, 0, `${this.myScene.storage.pet().coins}`, {
      fontSize: "40px",
      color: "#" +
        this.myScene.global.TUNER_TWA_CONFIG.palette.text.toString(16),
      fontFamily: "Phantom-Muff",
      fontStyle: "bold",
    })
      .setOrigin(0, 0.5)
      .setPosition(40, 0);

    this.add(this.text);
    this.add(this.image);

    // Добавляем обработчики событий для твина и перехода
    this.image.on("pointerover", () => this.onHover());
    this.image.on("pointerout", () => this.onOut());
    this.image.on("pointerdown", () => this.onClick());

    this.setValue(this.myScene.storage.pet().coins);

    this.myScene.registry.events.on("changedata-pet", () => {
      if (this.active) {
        this.setValue(this.myScene.storage.pet().coins);
      }
    });
  }

  setValue(value: number | null): void {
    if (value == null) return;
    if (this.text && this.text.active) {
      this.text.setText(`${value}`);
    }
  }

  private onHover(): void {
    // Останавливаем предыдущие твины
    this.myScene.tweens.killTweensOf(this.image);

    // Анимация увеличения и вращения
    this.myScene.tweens.add({
      targets: this.image,
      scaleX: 1.08,
      scaleY: 1.08,
      angle: Math.random() * 5 - 2.5,
      duration: 200,
      ease: "Power2",
    });
  }

  private onOut(): void {
    // Останавливаем предыдущие твины
    this.myScene.tweens.killTweensOf(this.image);

    // Анимация возврата к исходному состоянию
    this.myScene.tweens.add({
      targets: this.image,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      duration: 200,
      ease: "Power2",
    });
  }

  private onClick(): void {
    this.myScene.transition.toScene(
      "CurrencyShopScene",
      this.myScene.keys.strings.sceneTransitions.shop,
    );
  }

  override destroy(): void {
    this.image.destroy();
    this.text.destroy();
    super.destroy();
  }
}
